import { Component, effect, HostListener, Injector, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import * as REGEX from '../../../shared/regex';
import { MainService } from 'src/app/services/main.service';
import { SharedService, userProfile } from 'src/app/services/shared.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';
import { LegalConsentComponent } from 'src/app/pages/public/legal-consent/legal-consent.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { CaptchaService } from 'src/app/services/captcha.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.component.html',
  styleUrl: './business-info.component.scss',
  // import: [];
})
export class BusinessInfoComponent implements OnInit {
  public environment = environment;
  step = {
    BUSINESS_REGISTRATION: 'BUSINESS_REGISTRATION',
    VERIFY_OTP: 'VERIFY_OTP',
  };
  selectedStep = this.step.BUSINESS_REGISTRATION;
  industryList: any = [];
  country_list: any = [];
  sub_industries: any = [];
  practiceInfoForm: UntypedFormGroup = {} as UntypedFormGroup; // Default value
  mask: string = '000-000-0000';
  country_data: any;
  isDoctorMobileFocused = false;
  isPracticeMobileFocused = false;
  userProfile!: userProfile;
  showLogout: boolean = false;
  allowed_debt_type: any;
  bsModalRef: BsModalRef | undefined;
  otpForm: UntypedFormGroup;
  otpValueGroup = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  otp_id = 0;
  countries = [];
  last4Number: string = '';
  countdown: number = 180; // Countdown starts from 30 seconds
  countdownInterval: any;
  errorotp: any;
  google_id: string | undefined;
  checkBtn: boolean = false;
  // Google sign up skips the register screen, so the Terms and Privacy Policy are
  // reviewed here instead. Accepting in the modal is what enables Continue.
  legalAccepted: boolean = false;
  errorMessage: string | undefined;
  selectedDebt: string = '';
  selectedDebtTypes: string[] = [];
  private otpVerified = false;
  selectedCountry: any;
  registeredCountryId: any;
  
  constructor(
    private modalService: BsModalService,
    private _main: MainService,
    private formBuilder: UntypedFormBuilder,
    private apiSer: ApiService,
    private _shared: SharedService,
    private _local: localStorageService,
    private _loader: LoaderService,
    private cs: CaptchaService,
    private injector: Injector
  ) {
    this.otpForm = this.formBuilder.group({
      first: ['', [Validators.required, Validators.maxLength(1)]],
      second: ['', [Validators.required, Validators.maxLength(1)]],
      third: ['', [Validators.required, Validators.maxLength(1)]],
      fourth: ['', [Validators.required, Validators.maxLength(1)]],
      fifth: ['', [Validators.required, Validators.maxLength(1)]],
      sixth: ['', [Validators.required, Validators.maxLength(1)]],
    });
  }

  ngOnInit() {
    this.getIndustryList();
    // this.getcountryList();
    console.log("this", this.country_list);
    this.practiceInfoForm = this.formBuilder.group({
      practice_name: ['', [Validators.required, Validators.maxLength(100)]],
      practice_email: ['', [Validators.required, Validators.pattern(REGEX.Email), Validators.pattern(/^[a-zA-Z0-9@._%+-]+$/)]],
      practice_mobile: ['', [Validators.required, Validators.pattern(REGEX.number_regex)]],
      ind_name: [''],
      ind_id: ['', [Validators.required]],
      doctor_speciality_name: [''],
      doctor_mobile: ['', Validators.required],
      doctor_speciality: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      country_code: ['', [Validators.required]]
    });
    this.allowed_debt_type = this._local.customGetItem('userProfileData').allowed_debt_type
    this.updateSubIndustryFieldState();
    effect(() => {
      const data = this._shared.country_currency_info();
      if (data && data.country) {
        this.country_data = data.country;
        this.mask = data.country['country_phone_format'];
        this.registeredCountryId = data.country['country_id'];
        this.setDefaultCountry();
      }
    }, { injector: this.injector, allowSignalWrites: true });
    effect(() => {
      const countries = this._shared.country_data();
      this.countries = countries;
      // country_list drives setDefaultCountry()/getMobileCode(); keep it in sync
      // with the shared list, then (re)resolve the default selection so the
      // mobile code is available even before country_currency_info arrives.
      this.country_list = Array.isArray(countries) ? countries : [];
      this.setDefaultCountry();
    }, { injector: this.injector, allowSignalWrites: true });
    effect(() => {
      const doctorProfile: userProfile = this._shared.doctorProfile();
      this.userProfile = doctorProfile;
      this.google_id = this.userProfile.google_id;
      console.log(this.google_id, 'google_id google_id google_id');
    }, { injector: this.injector, allowSignalWrites: true });
    this.practiceInfoForm
      .get('ind_id')
      ?.valueChanges.subscribe((indIdValue) => {
        const indNameControl = this.practiceInfoForm.get('ind_name');
        console.log(indIdValue, 'indIdValueindIdValue');

        // debugger
        if (indIdValue == 9999) {
          indNameControl?.setValidators([Validators.required]);
        } else {
          indNameControl?.clearValidators();
        }
        indNameControl?.updateValueAndValidity();
      });


    // sanitize name fields on every change
    const nameFields = [
      'firstName',
      'lastName',
      'practice_name',
      'ind_name',
      'doctor_speciality_name',
    ];
    nameFields.forEach((field) => {
      const control = this.practiceInfoForm.get(field);
      if (control) {
        control.valueChanges.subscribe((val) => {
          if (val) {
            const cleaned = val.replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
            if (val !== cleaned) {
              control.setValue(cleaned, { emitEvent: false });
            }
          }
        });
      }
    });
  }

  getIndustryList() {
    this.apiSer
      .api({ is_verified: 1 }, 'profile/get_industry_list', 'get')
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.industryList = data.industries;
          // if (this.industryList && this.industryList.length) {
          //   if (this.industryList[0]['ind_id'] == 9999) {
          //     this.practiceInfoForm.controls['ind_name'].setValidators([Validators.required])
          //   }
          //   this.practiceInfoForm.patchValue({ ind_id: this.industryList[0]['ind_id'] });
          //   this.practiceInfoForm.patchValue({ ind_name: '' });
          // }
          // this.getSubIndustrylist();
        } else {
          this.industryList = [];
        }
      });
  }
  onCountryChange(event: Event) {
    const country_id = (event.target as HTMLSelectElement).value;
    const country = this.country_list.find(
      (c: any) => String(c.country_id) === String(country_id)
    );
    if (country) {
      this.applyCountrySelection(country, true);
    }
  }

  applyCountrySelection(country: any, clearPhones = false) {
    this.selectedCountry = country;
    this.country_data = country;
    this.mask = country.country_phone_format || '000-000-0000';
    this.practiceInfoForm.patchValue({ country_code: country.country_id });
    if (clearPhones) {
      this.practiceInfoForm.patchValue({ doctor_mobile: '', practice_mobile: '' });
      this.practiceInfoForm.get('doctor_mobile')?.markAsUntouched();
      this.practiceInfoForm.get('practice_mobile')?.markAsUntouched();
    }
  }

  setDefaultCountry() {
    if (!this.country_list?.length) {
      return;
    }
    const registeredId = this.registeredCountryId || this._local.customGetItem('register_country_id');
    const country =
      (registeredId && this.country_list.find((c: any) => String(c.country_id) === String(registeredId))) ||
      this.country_list.find((c: any) => String(c.country_code).toUpperCase() === 'US') ||
      this.country_list.find((c: any) => c.mobile_code === '+1') ||
      this.country_list[0];
    if (country) {
      this.applyCountrySelection(country, false);
    }
  }

  getMobileCode(): string {
    return this.selectedCountry?.mobile_code || this.country_data?.mobile_code || '+1';
  }

  getPhoneInputPadding(): string {
    const codeLength = this.getMobileCode().length;
    return `${16 + codeLength * 10 + 6}px`;
  }

  checkOtherVlaue(event: any) {
    const subInd: any = this.practiceInfoForm.get('doctor_speciality_name');
    const value = event.target.value;
    if (value == 9999) {
      this.practiceInfoForm.controls['doctor_speciality_name'].setValidators([
        Validators.required,
        this.noWhitespaceValidator(),
      ]);
    } else {
      this.practiceInfoForm.controls[
        'doctor_speciality_name'
      ].clearValidators();
    }
    subInd.updateValueAndValidity();
  }

  getSubIndustrylist() {
    this.practiceInfoForm.patchValue({
      doctor_speciality: '',
      doctor_speciality_name: '',
    });

    const data = {
      ind_id: parseInt(this.practiceInfoForm.controls['ind_id'].value),
      is_deleted: 0,
      is_verified: 1,
      full_data: 0,
    };
    this.apiSer
      .api(data, 'profile/get_all_sub_industries', 'get')
      .subscribe((data: any) => {
        if (data && data.is_error == 0 && data.doctor_specialities) {
          // const data = resData.doctor_specialities;
          if (data.doctor_specialities && data.doctor_specialities.length) {
            if (data.doctor_specialities[0]['doctor_speciality'] == 9999) {
              this.practiceInfoForm.controls[
                'doctor_speciality_name'
              ].setValidators([
                Validators.required,
                this.noWhitespaceValidator(),
              ]);
            } else {
              this.practiceInfoForm.controls[
                'doctor_speciality_name'
              ].clearValidators();
            }
            this.practiceInfoForm.patchValue({
              doctor_speciality: data.doctor_specialities[0].doctor_speciality,
            });
            this.practiceInfoForm.patchValue({ doctor_speciality_name: '' });
          }
          this.sub_industries = data.doctor_specialities;
          this.updateSubIndustryFieldState();
          this.practiceInfoForm.updateValueAndValidity();
        } else {
          this.sub_industries = [];
          if (this.practiceInfoForm.controls['ind_id'].value == 9999){
            this.practiceInfoForm.patchValue({ 'doctor_speciality': 9999 });
          }else {
            this.practiceInfoForm.patchValue({ 'doctor_speciality': "" });
          }
          this.practiceInfoForm.patchValue({ 'doctor_speciality_name': '' });
          this.updateSubIndustryFieldState();
        }
      });
  }

  private updateSubIndustryFieldState(): void {
    const control = this.practiceInfoForm.get('doctor_speciality');
    if (!control) {
      return;
    }

    if (this.sub_industries?.length) {
      control.enable({ emitEvent: false });
    } else {
      control.disable({ emitEvent: false });
    }
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }
  trimInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.practiceInfoForm.controls['doctor_speciality_name'].setValue(
      inputElement.value.trim(),
      { emitEvent: false }
    );
  }


  get isContinueDisabled(): boolean {
    return (
      (this.allowed_debt_type == 3 && !this.selectedDebtTypes.length) ||
      (!!this.google_id && !this.checkBtn)
    );
  }

  submitPracticeInfo() {
    if (this.isContinueDisabled) {
      return;
    }

    if (this.practiceInfoForm.invalid) {
      this.practiceInfoForm.markAsDirty();
      this.practiceInfoForm.markAllAsTouched();
      return;
    }

    this.verifyPhoneNumber();
  }


  verifyOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAsDirty();
      this.otpForm.markAllAsTouched();
      return;
    }
    let data;
    let value = '';
    this.otpValueGroup.filter((input) => (value += this.otpForm.value[input]));
    data = {
      otp: value,
      otp_id: this.otp_id,
    };
    this.apiSer.api(data, 'profile/verify_otp').subscribe((data) => {
      if (data.is_error == 0) {
        const data = {
          practice_name:
            this.practiceInfoForm.controls['practice_name'].value.trim(),
          practice_email:
            this.practiceInfoForm.controls['practice_email'].value,
          doctor_mobile:
            this.practiceInfoForm.controls['doctor_mobile'].value + '',
          practice_mobile:
            this.practiceInfoForm.controls['practice_mobile'].value + '',
          practice_mobile_country_code: this.selectedCountry?.mobile_code || '+1',
          doctor_mobile_country_code: this.selectedCountry?.mobile_code || '+1',
          ind_id: this.practiceInfoForm.controls['ind_id'].value,
          sub_ind_id: this.practiceInfoForm.controls['doctor_speciality'].value,
          ind_name: this.practiceInfoForm.controls['ind_name'].value,
          sub_ind_name:
            this.practiceInfoForm.controls['doctor_speciality_name'].value,
          doctor_name:
            this.practiceInfoForm.controls['firstName'].value.trim() +
            ' ' +
            this.practiceInfoForm.controls['lastName'].value.trim(),
          doctor_debt_type:
            this.selectedDebtTypes.length == 2
              ? 3
              : this.selectedDebtTypes[0] == 'commercial'
              ? 2
              : 1,
          country_id: this.practiceInfoForm.controls['country_code'].value,
          currency_id: this.selectedCountry?.currency?.[0]?.currency_id,
          cocu_id: this.selectedCountry?.currency?.[0]?.cocu_id,
          // Only the Google path accepts the Terms here, so only it sends the
          // capture. An email sign up already had it stored by registerDoctor,
          // and its capture is still sitting in localStorage - sending it again
          // would re-upload the same image and overwrite tnc_ip with this
          // request's address. legalAccepted is set by the card, which only
          // renders when google_id is present.
          legal_consent: this.legalAccepted
            ? LegalConsentComponent.storedAcceptanceCapture()
            : null,
        };
        if (this.selectedDebtTypes.length) {
          data.doctor_debt_type =
            this.selectedDebtTypes.length == 2
              ? 3
              : this.selectedDebtTypes[0] == 'commercial'
                ? 2
                : 1;
        }
        this.apiSer.api(data, 'profile/business_setting').subscribe((data) => {
          if (data.is_error == 0) {
            this._main.accessTokenLogin();
          } else {
            this.practiceInfoForm.markAsDirty();
            this.practiceInfoForm.markAsTouched();
            window.scroll(0, 0);
          }
        });
      } else {
        this.errorotp = data.original_text;
        console.log(this.errorotp, 'this.errorotpthis.errorotp');
        this.otpForm.setErrors({ credentialsMismatch: true });
        this.otpForm.markAsDirty();
        this.otpForm.markAsTouched();
        window.scroll(0, 0);
      }
    });
  }

  renewOtp(): void {
    // Generate a new OTP and reset countdown
    this.verifyPhoneNumber();
    this.countdown = 180; // Reset countdown to 180 seconds
    // this.startCountdown();
  }

  startCountdown(): void {
    // Initialize countdown interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval); // Stop countdown when it reaches 0
      }
    }, 1000); // 1000ms = 1 second
  }

  async verifyPhoneNumber() {
    this.startCountdown();
    try {
      let data;
      this._loader.showLoader();
      const mobileNumber =
        this.practiceInfoForm.controls['doctor_mobile'].value + '';
      const doctor_eamil =
        this.practiceInfoForm.controls['practice_email'].value + '';
      this.last4Number = mobileNumber.substring(
        mobileNumber.length - 4,
        mobileNumber.length
      );
      const captcha = await this.cs.getCaptchaToken();
      // console.log('Captcha token:', token);
      data = {
        doctor_mobile: mobileNumber,
        doctor_email: doctor_eamil,
        captcha,
        doctor_mobile_country_code: this.selectedCountry?.mobile_code || '+1',
      };
      this.apiSer.api(data, 'profile/send_otp').subscribe((data) => {
        if (data.is_error == 0) {
          if (data.otp_id) {
            this.otp_id = data.otp_id;
          }
          this.selectedStep = this.step.VERIFY_OTP;
          this.checkBtn = false;
          if (data.otp && !environment.production) {
            this._shared.customPopups(data.otp, 0);
          }
        } else {
          this.errorMessage = data.original_text;
          this._shared.customPopups(`${this.errorMessage}`, 1);
        }
      });
    } catch (error) {
      console.error('Failed to get captcha token', error);
      return;
    }
    // console.log(data);
  }

  showModal() {
    this.showLogout = true;
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  onInput(event: any, currentIndex: number, method: any = ''): void {
    const inputValue = method === 'paste' ? event : event.target.value;

    if (!(inputValue >= 0) || !(inputValue < 10)) {
      this.otpForm.get(this.otpValueGroup[currentIndex])?.setValue('');
      return;
    }

    if (inputValue && currentIndex < this.otpValueGroup.length - 1) {
      const nextInput = this.otpValueGroup[currentIndex + 1];
      this.setFocus(nextInput);
    }

    if (
      currentIndex === this.otpValueGroup.length - 1 &&
      inputValue &&
      !this.otpVerified
    ) {
      this.otpVerified = true; // Set flag to avoid repeated calls
      setTimeout(() => {
        this.verifyOtp();
      }, 100);
    }
  }

  onPasteHandler(data: any) {
    if (data <= 999999) {
      let splitData = data.split('');
      for (let i = 0; i < splitData.length; i++) {
        this.otpForm.controls[this.otpValueGroup[i]].patchValue(splitData[i]);
      }
      this.onInput(
        splitData[splitData.length - 1],
        splitData.length - 2,
        'paste'
      );
    }
  }

  onDelete(event: any, currentIndex: number): void {
    if (!event.target.value && currentIndex > 0) {
      const previousInput = this.otpValueGroup[currentIndex - 1];
      this.setFocus(previousInput);
    }
  }

  setFocus(input: string) {
    if (input) {
      document.getElementById(input)?.focus();
    }
  }

  logoutModal() {
    const initialState = {};
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {
      initialState,
      class: 'modal-dialog-centered',
    });
  }
  trimWhitespace(controlName: string): void {
    const control = this.practiceInfoForm.get(controlName);
    if (control && control.value) {
      control.setValue(control.value.trim());
    }
  }

  // The person accepting, so the modal can say who agreed. The form is prefilled
  // from the Google account, with the saved profile name as a fallback.
  get accepterName(): string {
    const first = (this.practiceInfoForm?.controls['firstName']?.value || '').trim();
    const last = (this.practiceInfoForm?.controls['lastName']?.value || '').trim();
    return [first, last].filter(Boolean).join(' ') || (this.userProfile?.doctor_name || '').trim();
  }

  // Opens the Terms and Privacy Policy modal; accepting there is what ticks the
  // agreement off, the same way the checkbox used to.
  showLegalModal() {
    if (this.legalAccepted) {
      return;
    }

    this.bsModalRef = this.modalService.show(LegalConsentComponent, {
      initialState: {
        userEmail: (this.userProfile?.doctor_email || '').trim(),
        accepterName: this.accepterName
      },
      class: 'modal-dialog-centered legal-modal-wrapper',
      ignoreBackdropClick: true
    });

    this.bsModalRef.content.onAccept.subscribe(() => {
      this.legalAccepted = true;
      this.checkBtn = true;
    });
  }

  checkedTerms() {
    if (this.google_id != '') {
      this.checkBtn = !this.checkBtn;
    }
    // debugger
  }
  continueNext() {
    console.log('Selected debt type:', this.selectedDebt);
    // logic to move to next step or submit
  }

  // toggle selecting a debt type card (consumer / commercial)
  toggleDebtType(type: 'consumer' | 'commercial') {
    this.customerTouched = true;

    const idx = this.selectedDebtTypes.indexOf(type);
    if (idx > -1) {
      this.selectedDebtTypes.splice(idx, 1);
    } else {
      this.selectedDebtTypes.push(type);
    }

    // Update missing3: true if nothing selected
    this.missing3 = this.selectedDebtTypes.length === 0;
  }

  //handle weather values in incomplete or not
  get isContactInfoIncomplete(): boolean {
    const controls = this.practiceInfoForm.controls;
     if (
      !controls['country_code']?.value ||
      controls['country_code']?.invalid ||
      !controls['firstName']?.value?.trim() || controls['firstName']?.invalid ||
      !controls['lastName']?.value?.trim() ||  controls['lastName']?.invalid ||
      !controls['doctor_mobile']?.value?.trim() || controls['doctor_mobile']?.invalid 
    ) {
      return true;
    }
    return false
  }

  get isBusinessInfoIncomplete(): boolean {
    const controls = this.practiceInfoForm.controls as any;

    // If any main required field is missing or invalid
    if (
      !controls['practice_name']?.value?.trim() ||
      controls['practice_name']?.invalid ||
      !controls['practice_email']?.value?.trim() ||
      controls['practice_email']?.invalid ||
      !controls['practice_mobile']?.value?.trim() ||
      controls['practice_mobile']?.invalid ||
      !controls['ind_id']?.value ||
      controls['ind_id']?.invalid ||
      !controls['doctor_speciality']?.value ||
      controls['doctor_speciality']?.invalid
    ) {
      return true;
    }

    // If Industry is "Others" (id = 9999) → validate both extra fields
    if (controls['ind_id']?.value == 9999) {
      if (
        !controls['ind_name']?.value?.trim() ||
        controls['ind_name']?.invalid ||
        !controls['doctor_speciality_name']?.value?.trim() ||
        controls['doctor_speciality_name']?.invalid
      ) {
        return true;
      }
    }

    // If doctor_speciality is "Others" (id = 9999) → validate sub-industry name
    if (controls['doctor_speciality']?.value == 9999) {
      if (
        !controls['doctor_speciality_name']?.value?.trim() ||
        controls['doctor_speciality_name']?.invalid
      ) {
        return true;
      }
    }

    return false; // all required business info fields are filled and valid
  }

  get isCustomerTypeIncomplete(): boolean {
    return this.selectedDebtTypes.length === 0;
  }

  // handle Missing Information
  contactTouched = false;
  businessTouched = false;
  customerTouched = false;
  missing1: any = false;
  missing2: any = false;
  missing3: any = false;

checkInfo(step: number, isOpen: boolean) {
  // this.updateMissingStates();

  if (step === 1) {
    this.contactTouched = true;

    if (isOpen) {
      this.missing1 = false;
    } else {
      this.missing1 = this.isContactInfoIncomplete;
    }
  } 
  else if (step === 2) {
    this.businessTouched = true;

    if (isOpen) {
      this.missing2 = false;
    } else {
      this.missing2 = this.isBusinessInfoIncomplete;
    }
  } 
  else if (step === 3) {
    this.customerTouched = true;

    if (isOpen) {
      this.missing3 = false;
    } else {
      this.missing3 = this.isCustomerTypeIncomplete;
    }
  }

  // Optional: recheck others when one closes
  if (!isOpen) {
    if (this.isContactInfoIncomplete && step == 1) this.missing1 = true;
    if (this.isBusinessInfoIncomplete && step == 2) this.missing2 = true;
    if (this.isCustomerTypeIncomplete && step == 3) this.missing3 = true;
  }
}



  // private updateMissingStates(): void {
  //   this.missing1 = this.contactTouched ? this.isContactInfoIncomplete : false;
  //   this.missing2 = this.businessTouched? this.isBusinessInfoIncomplete: false;
  //   this.missing3 = this.customerTouched? this.isCustomerTypeIncomplete: false;
  // }
}
